import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Avatar from 'flarum/common/components/Avatar';
export default class LeaderboardItem extends Component {
  view() {
    const {
      entry,
      pointsLabel
    } = this.attrs;
    const user = entry.user();
    const rank = entry.rank();
    return m(Link, {
      href: user ? app.route('user', {
        username: user.slug()
      }) : '#',
      className: "LeaderboardItem"
    }, m("span", {
      className: "LeaderboardItem-rank"
    }, "#", rank), m("span", {
      className: "LeaderboardItem-avatar"
    }, user ? m(Avatar, {
      user: user
    }) : m("span", {
      className: "Avatar"
    }, "?")), m("span", {
      className: "LeaderboardItem-name"
    }, user ? user.displayName() : '?'), m("span", {
      className: "LeaderboardItem-points"
    }, entry.points(), " ", pointsLabel));
  }
}
flarum.reg.add('huseyinfiliz-leaderboard', 'forum/components/LeaderboardItem', LeaderboardItem);